import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-transparent"
}
const _hoisted_2 = {
  class: "flex items-center justify-between p-6 lg:px-8 max-w-full",
  "aria-label": "Global"
}
const _hoisted_3 = { class: "flex lg:flex-1" }
const _hoisted_4 = {
  href: "/",
  class: "-m-1.5 p-1.5"
}
const _hoisted_5 = { class: "flex lg:hidden" }
const _hoisted_6 = { class: "hidden lg:flex lg:gap-x-12" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "flex items-center justify-between" }
const _hoisted_9 = {
  href: "#",
  class: "-m-1.5 p-1.5"
}
const _hoisted_10 = { class: "mt-6 flow-root" }
const _hoisted_11 = { class: "-my-6 divide-y divide-gray-500/25" }
const _hoisted_12 = { class: "space-y-2 py-6 font-poppins text-center" }
const _hoisted_13 = ["href"]

import Footer from './components/structure/Footer.vue';
import Navbar from './components/structure/Navbar.vue';
import Container from './components/content/Container.vue';
import { injectStrict } from './plugins/vueServiceContainerPlugin';
import { CatalogAdapterInterface } from './adapters/catalogAdapterInterface';
import { OutageAdapterInterface } from './adapters/outageAdapterInterface';
import store from './store';
import { BrandServiceInterface } from './services/brand/brandServiceInterface';
import router from './router';
import Account from './components/Account.vue';
import { AuthenticationServiceInterface } from './services/authentication/authenticationServiceInterface';
import { Brand } from './services/integration/enums';
import Logo from './components/content/Logo.vue';
import { useRoute } from 'vue-router';
import { onMounted, ref, onBeforeUnmount } from 'vue';
import { MenuIcon, XIcon } from '@heroicons/vue/outline';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

const catalogAdapter = injectStrict<CatalogAdapterInterface>('CatalogAdapterInterface');
const outageAdapter = injectStrict<OutageAdapterInterface>('OutageAdapterInterface');
const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');
const authenticationService = injectStrict<AuthenticationServiceInterface>('AuthenticationServiceInterface');

// Data.
const footerLinks = [
  { name: 'Privacy', href: '/privacy-policy' },
  { name: 'Complaints', href: '/complaints' },
  { name: 'Legal', href: '/legal' },
  { name: 'Outages', href: '/outage' },
  { name: 'Family, Domestic & Sexual Violence Support', href: '/dfsv' }
];

let headerLinks = [
  { name: 'Features', href: '/#features' },
  { name: 'Plans', href: '/#plans' },
  { name: 'Contact', href: '/#contact' }
];

const navigation = [
  { name: 'Features', href: '/#features' },
  { name: 'Plans', href: '/#plans' },
  { name: 'Contact', href: '/#contact' }
];

const mobileMenuOpen = ref(false);
if (brandService.getName() === Brand.JAM) {
  headerLinks = [];
}

// Events
const unitiRedirect = async () => {
  router.push('/uniti');
};

// Events
const nexeeRedirect = async () => {
  router.push('/nexee');
};

if (brandService.getName() === Brand.JAM) {
  unitiRedirect();
}

if (brandService.getName() === Brand.HIS) {
  nexeeRedirect();
}
const getSalesPerson = async () => {
  const validSales = ['joshua.james@unitiinternet.com', 'jaben.heyworth@unitiinternet.com', 'abee.sharma@unitiinternet.com', 'kay.nguyen@unitiinternet.com', 'priya.ogirala@unitiinternet.com', 'aman.kaur@unitiinternet.com'];
  if (route.query.salesPerson && validSales.includes(route.query.salesPerson.toString().toLowerCase())) {
    store.commit('setSalesPerson', route.query.salesPerson.toString());
  }
};

onMounted(async () => {
  window.addEventListener('scroll', handleScroll);
  // get sales person
  await router.isReady();
  await getSalesPerson();
  store.commit('setPaymentAttempt', 0);
});

const isScrolled = ref(false);

function handleScroll () {
  isScrolled.value = window.scrollY > 50;
}

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll);
});

const ctaClicked = () => {
  // When the CTA in the navbar is clicked, focus
  // the main address element if it exists.
  const el = document.getElementById('primary-address-search');
  if (el) {
    el.focus();
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center'
    });
  } else {
    store.commit('setServiceQualification', null);
    router.push('/');
  }
};

// Get catalog for the rest of the site.
const getCatalog = async () => {
  const catalog = await catalogAdapter.getCatalog(brandService.getName());
  store.commit('setCatalog', catalog);
};
getCatalog();

// Initialise use account.
const getAccount = async () => {
  const account = await authenticationService.getAccount();
  store.commit('setAccount', account);
};
getAccount();

const getOutages = async () => {
  const outages = await outageAdapter.fetchOutages();
  store.commit('setOutages', outages);
};
getOutages();

// Set the page title and favicon.
document.title = brandService.getTitle();
const link = document.createElement('link');
link.id = 'favicon';
link.rel = 'shortcut icon';
link.href = brandService.getFavicon();
document.head.appendChild(link);

return (_ctx: any,_cache: any) => {
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Account),
    (_unref(brandService).getName() === _unref(Brand).NEX)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("header", {
            class: _normalizeClass(["z-50 header-nav", [
      'fixed top-0 left-0 w-full transition-colors duration-300 z-50',
      isScrolled.value ? 'bg-white text-black' : 'bg-transparent text-white'
    ]])
          }, [
            _createElementVNode("nav", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("a", _hoisted_4, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "sr-only" }, "Your Company", -1)),
                  _createVNode(Logo)
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  type: "button",
                  class: "-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-black",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (mobileMenuOpen.value = true))
                }, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "sr-only" }, "Open main menu", -1)),
                  _createVNode(_unref(MenuIcon), {
                    class: "size-6",
                    "aria-hidden": "true"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headerLinks), (item) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: item.name,
                    href: item.href,
                    class: "text-sm/6 font-poppins text-black no-underline hover:border hover:border-solid hover:border-brand-primary px-6 py-1 rounded-full"
                  }, _toDisplayString(item.name), 9, _hoisted_7))
                }), 128))
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "hidden lg:flex lg:flex-1 lg:justify-end lg:gap-x-6" }, [
                _createElementVNode("a", {
                  href: "/about-us",
                  class: "text-sm/6 font-poppins text-black no-underline border border-solid border-brand-primary px-6 py-1 rounded-full hover:bg-black hover:text-white bg-transparent"
                }, "About Us"),
                _createElementVNode("a", {
                  href: "https://my.nexee.au",
                  class: "text-sm/6 font-poppins text-black no-underline border border-solid border-brand-primary px-6 py-1 rounded-full hover:bg-black hover:text-white bg-transparent"
                }, "Log in")
              ], -1))
            ]),
            _createVNode(_component_Dialog, {
              class: "lg:hidden",
              onClose: _cache[3] || (_cache[3] = ($event: any) => (mobileMenuOpen.value = false)),
              open: mobileMenuOpen.value
            }, {
              default: _withCtx(() => [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "fixed inset-0 z-100" }, null, -1)),
                _createVNode(_component_DialogPanel, { class: "fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 max-w-sm sm:ring-1 sm:ring-white/10" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("a", _hoisted_9, [
                        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "sr-only" }, "Your Company", -1)),
                        _createVNode(Logo)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "-m-2.5 rounded-md p-2.5 text-black",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (mobileMenuOpen.value = false))
                      }, [
                        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "sr-only" }, "Close menu", -1)),
                        _createVNode(_unref(XIcon), {
                          class: "size-6",
                          "aria-hidden": "true"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                            return _createElementVNode("a", {
                              key: item.name,
                              href: item.href,
                              class: "-mx-3 block rounded-lg px-3 py-2 text-base/7 font-bold text-black hover:text-gray-800",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (mobileMenuOpen.value = false))
                            }, _toDisplayString(item.name), 9, _hoisted_13)
                          }), 64))
                        ]),
                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "py-6" }, [
                          _createElementVNode("a", {
                            href: "https://my.nexee.au",
                            class: "-mx-3 block rounded-lg px-3 py-2.5 text-base/7 font-semibold text-white hover:bg-gray-800"
                          }, "Log in")
                        ], -1))
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1,
              __: [10]
            }, 8, ["open"])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    _withDirectives(_createVNode(Footer, {
      class: "",
      main: footerLinks
    }, null, 512), [
      [_vShow, _unref(brandService).getName() === _unref(Brand).NEX]
    ])
  ], 64))
}
}

})